import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TrackingCmsComponents } from '@core/const';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { TrackingPickupSchemeComponentModule } from './tracking-pickup-scheme/tracking-pickup-scheme.module';
import { TrackingPickupComponent } from './tracking-pickup.component';
@NgModule({
  declarations: [TrackingPickupComponent],
  imports: [
    NgIf,
    NgFor,
    NgClass,
    DatePipe,
    AsyncPipe,
    RouterLink,
    SdvorButtonComponent,
    UrlModule,
    IconModule,
    TrackingPickupSchemeComponentModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [TrackingCmsComponents.PickupTrackingComponent]: {
          component: TrackingPickupComponent,
        },
      },
    }),
  ],
})
export class TrackingPickupComponentModule {}
